import { Component, Input } from '@angular/core';
import { RegularWithdrawalMessageModalInput } from '../../modal';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'libero-withdrawal-draft-comment-modal',
  templateUrl: './withdrawal-draft-comment-modal.component.html',
  styleUrl: './withdrawal-draft-comment-modal.component.scss',
  standalone: false,
})
export class WithdrawalDraftCommentModalComponent {
  @Input({ required: true }) public draftWithdrawalComment: RegularWithdrawalMessageModalInput | null = null;

  public get displayPhoto(): SafeUrl | string | null {
    return this.draftWithdrawalComment?.colaborator.hasPhoto ? this.draftWithdrawalComment.colaboratorPhotoUrl : null;
  }
}
